export default "__VITE_ASSET__DKQRAWp4__"